import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';

function statusBadge(status) {
  const colors = {
    completed: '#28a745',
    processing: '#ffc107',
    'on-hold': '#fd7e14',
    pending: '#6c757d',
    cancelled: '#dc3545',
    refunded: '#6f42c1',
    failed: '#dc3545',
    active: '#28a745',
    'pending-cancel': '#fd7e14',
    expired: '#6c757d',
    'on-hold': '#fd7e14',
  };

  const bg = colors[status] || '#6c757d';

  return m(
    'span',
    {
      style: {
        display: 'inline-block',
        padding: '2px 8px',
        borderRadius: '3px',
        fontSize: '12px',
        fontWeight: 'bold',
        color: '#fff',
        backgroundColor: bg,
        textTransform: 'capitalize',
      },
    },
    status.replace(/-/g, ' ')
  );
}

export default class MyOrdersPage extends Page {
  oninit(vnode) {
    super.oninit(vnode);
    this.loading = true;
    this.orders = [];
    this.subscriptions = [];
    this.error = null;
    this.loadOrders();
  }

  loadOrders() {
    app
      .request({ method: 'GET', url: app.forum.attribute('apiUrl') + '/wp-orders' })
      .then((data) => {
        this.orders = data.orders || [];
        this.subscriptions = data.subscriptions || [];
        this.loading = false;
        m.redraw();
      })
      .catch(() => {
        this.error = 'Failed to load orders. Please try again later.';
        this.loading = false;
        m.redraw();
      });
  }

  view() {
    return m('.IndexPage', [
      m('.container', { style: { maxWidth: '900px', margin: '0 auto', padding: '20px 0' } }, [
        m('h2', { style: { marginBottom: '20px' } }, 'My Orders'),

        this.loading
          ? m('.ContentPlaceholder', m(LoadingIndicator))
          : this.error
          ? m('.Placeholder', m('p', this.error))
          : this.viewContent(),
      ]),
    ]);
  }

  viewContent() {
    return m('div', [
      this.subscriptions.length > 0 && this.viewSubscriptions(),
      this.viewOrders(),
    ]);
  }

  viewSubscriptions() {
    return m('div', { style: { marginBottom: '30px' } }, [
      m('h3', { style: { marginBottom: '12px', fontSize: '18px' } }, 'Subscriptions'),
      m(
        'table.Table',
        {
          style: {
            width: '100%',
            borderCollapse: 'collapse',
            backgroundColor: 'var(--body-bg, #fff)',
          },
        },
        [
          m('thead', [
            m('tr', { style: { borderBottom: '2px solid var(--control-bg, #e8ecf3)' } }, [
              m('th', { style: thStyle() }, 'Product'),
              m('th', { style: thStyle() }, 'Status'),
              m('th', { style: thStyle() }, 'Start Date'),
              m('th', { style: thStyle() }, 'Next Payment'),
              m('th', { style: thStyle({ textAlign: 'right' }) }, 'Total'),
            ]),
          ]),
          m(
            'tbody',
            this.subscriptions.map((sub) =>
              m('tr', { style: { borderBottom: '1px solid var(--control-bg, #e8ecf3)' } }, [
                m('td', { style: tdStyle() }, sub.items.map((i) => i.name).join(', ') || 'Subscription #' + sub.id),
                m('td', { style: tdStyle() }, statusBadge(sub.status)),
                m('td', { style: tdStyle() }, sub.start_date || '-'),
                m('td', { style: tdStyle() }, sub.next_payment || '-'),
                m('td', { style: tdStyle({ textAlign: 'right' }) }, sub.items.map((i) => '$' + i.total).join(', ')),
              ])
            )
          ),
        ]
      ),
    ]);
  }

  viewOrders() {
    if (this.orders.length === 0 && this.subscriptions.length === 0) {
      return m('.Placeholder', { style: { textAlign: 'center', padding: '40px 0' } }, [
        m('p', { style: { fontSize: '16px', color: 'var(--muted-color, #999)' } }, "You don't have any orders yet."),
        m(
          'a.Button.Button--primary',
          { href: 'https://pablomartin.com/shop/', target: '_blank' },
          'Visit Shop'
        ),
      ]);
    }

    if (this.orders.length === 0) {
      return null;
    }

    return m('div', [
      m('h3', { style: { marginBottom: '12px', fontSize: '18px' } }, 'Orders'),
      m(
        'table.Table',
        {
          style: {
            width: '100%',
            borderCollapse: 'collapse',
            backgroundColor: 'var(--body-bg, #fff)',
          },
        },
        [
          m('thead', [
            m('tr', { style: { borderBottom: '2px solid var(--control-bg, #e8ecf3)' } }, [
              m('th', { style: thStyle() }, 'Date'),
              m('th', { style: thStyle() }, 'Product'),
              m('th', { style: thStyle() }, 'Status'),
              m('th', { style: thStyle({ textAlign: 'right' }) }, 'Total'),
            ]),
          ]),
          m(
            'tbody',
            this.orders.map((order) =>
              m('tr', { style: { borderBottom: '1px solid var(--control-bg, #e8ecf3)' } }, [
                m('td', { style: tdStyle() }, order.date || '-'),
                m(
                  'td',
                  { style: tdStyle() },
                  order.items.map((i) => i.name + (i.quantity > 1 ? ' x' + i.quantity : '')).join(', ') ||
                    'Order #' + order.id
                ),
                m('td', { style: tdStyle() }, statusBadge(order.status)),
                m(
                  'td',
                  { style: tdStyle({ textAlign: 'right' }) },
                  '$' + order.total + ' ' + (order.currency || '')
                ),
              ])
            )
          ),
        ]
      ),
    ]);
  }
}

function thStyle(extra) {
  return Object.assign(
    {
      padding: '10px 12px',
      textAlign: 'left',
      fontWeight: '600',
      fontSize: '13px',
      color: 'var(--muted-color, #999)',
      textTransform: 'uppercase',
    },
    extra || {}
  );
}

function tdStyle(extra) {
  return Object.assign(
    {
      padding: '10px 12px',
      fontSize: '14px',
    },
    extra || {}
  );
}
